// extracted by mini-css-extract-plugin
export default {"selectList":"styles-module--selectList--tvQru","arrowDown":"styles-module--arrowDown--JQl7T"};